import React, { useEffect, useRef, useState } from "react";
import { Box, Fab, Typography, useTheme, useMediaQuery } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import { gsap } from "gsap";
import LeadModal from "./LeadModal";
import { getProjectDetails } from "../../../../../api/services";
import { useQuery } from "@tanstack/react-query";

const BottomNav: React.FC = () => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navRef = useRef<HTMLDivElement | null>(null);
  const floatingBtnRef = useRef<HTMLButtonElement | null>(null);


    const slug = ""; // Replace with actual slug dynamically if needed

  const { data: projectResponse } = useQuery({
    queryKey: ["projectDetails", slug],
    queryFn: () => getProjectDetails(slug),
    enabled: !!slug,
  });

  const projectData = projectResponse?.data;

  // GSAP Animations - Entrance & Floating Motion
  useEffect(() => {
    if (navRef.current) {
      gsap.fromTo(
        navRef.current,
        { y: 100, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.6, ease: "power3.out" }
      );
    }

    if (floatingBtnRef.current) {
      gsap.to(floatingBtnRef.current, {
        y: -8,
        repeat: -1,
        yoyo: true,
        duration: 1.5,
        ease: "power1.inOut",
      });
    }
  }, []);

  if (!isMobile) return null; // Hide on desktop

  return (
    <Box
      ref={navRef}
      sx={{
        position: "fixed",
        bottom: 20,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1000,
        width: "95%",
      }}
    >
      {/* SVG Background Shape */}
      <svg
        viewBox="0 0 328 50"
        width="100%"
        height="60px"
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          zIndex: -1,
        }}
      >
        <path
          d="M 136.16 8.37203 C 132.106 3.74491 126.716 0 120.564 0 H 10 C 4.47715 0 0 4.47715 0 10 V 40 C 0 45.5228 4.47714 50 9.99999 50 H 318 C 323.523 50 328 45.5228 328 40 V 10 C 328 4.47715 323.523 0 318 0 H 207.436 C 201.284 0 195.894 3.74491 191.84 8.37202 C 185.058 16.1124 175.1 21 164 21 C 152.9 21 142.942 16.1124 136.16 8.37203 Z"
          fill="rgba(52, 52, 52, 0.75)" 
        />
      </svg>

      <Box
        sx={{
          position: "relative",
          width: "100%",
          margin: "0 auto",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          // padding: "15px 20px 10px",
        }}
      >
        {/* Left Button - Book A Site Visit */}
        <Box
          sx={{
            textAlign: "center",
            flex: 0.8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Fab
            size="small"
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
              color: "#FFFFFF", // White icon for dark background
              "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)" },
            }}
            onClick={() => window.location.href = "tel:+919885420885"}
          >
            <PhoneIcon sx={{ fontSize: "24px" }} />
          </Fab>
          <Typography variant="caption" sx={{ color: "#FFFFFF", fontSize: "12px" }}>
            Book A Site Visit
          </Typography>
        </Box>

        {/* Center Floating Button - Explore */}
        <Fab
          ref={floatingBtnRef}
          color="primary"
          aria-label="explore"
          sx={{
            position: "absolute",
            top: "-55px",
            left: "50%",
            transform: "translateX(-50%)",
            background: "#0f63a5",
            color: "#fff",
            // "&:hover": { backgroundColor: "linear-gradient(45deg, rgb(185, 112, 44),rgb(21
            // 25, 129, 48),)" },
            boxShadow: "0px 6px 18px #0f63a5",
            width: "70px",
            height: "70px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => setIsOpen(true)}        >
          <DownloadRoundedIcon sx={{ fontSize: "34px" }} />
        </Fab>

        {/* Center Label - "Explore" */}
        <Typography
          variant="caption"
          sx={{
            position: "absolute",
            bottom: 8,
            left: "50%",
            transform: "translateX(-50%)",
            color: "#FFFFFF", // White text for dark background
            fontWeight: "bold",
            fontSize: "12px",
          }}
        >
          Explore
        </Typography>

        <Box sx={{ flex: 0.35 }} />

        {/* Right Button - WhatsApp */}
        <Box
          sx={{
            textAlign: "center",
            flex: 0.8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Fab
            size="small"
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
              color: "#25D366", // WhatsApp green color
              "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)" },
            }}
            onClick={() => window.open("https://wa.me/+919885420885", "_blank")}
          >
            <WhatsAppIcon sx={{ fontSize: "24px" }} />
          </Fab>
          <Typography variant="caption" sx={{ color: "#FFFFFF", fontSize: "12px" }}>
            WhatsApp
          </Typography>
        </Box>
      </Box>
              {/* <LeadModal isOpen={isOpen} onClose={() => setIsOpen(false)} /> */}
                   <LeadModal
  isOpen={isOpen}
  onClose={() => setIsOpen(false)}
  projectSlug={projectData?.projectdetails?.slug || ""}
  projectTitle={projectData?.projectdetails?.title || ""}
/>
      
    </Box>
  );
};

export default BottomNav;
